import { RxDocument } from "rxdb";
import { DatabaseProvider } from "../db/db-setup.js";
import { useContext, useEffect, useState, useRef } from "preact/hooks";
import { ChatMessageType } from "../db/chatMessages.js";
import { localConfigStorage } from "../util/local-config.js";
import { authClient } from "../db/db-setup.js";
import { last } from "rxjs";

function stringToPastelColor(str: string) {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    h >>>= 0;

    const hue = (((h / 2**32) + 0.61803398875) % 1) * 360;
    const sat = 45 + ((h >>> 9) % 25);    // 45–69%
    const light = 82 + ((h >>> 18) % 10); // 82–91%

    return `hsl(${hue} ${sat}% ${light}%)`;
}

export function Chat({}) {
    const db = useContext(DatabaseProvider);
    const scrollEnd = useRef<HTMLDivElement>(null);
    const scrollablePane = useRef<HTMLDivElement>(null);
    const [lastMessageId, setLastMessageId] = useState<string | null>(null);

    const [messages, setMessages] = useState([] as RxDocument<ChatMessageType>[]);
    useEffect(() => {
        if (db) {
            db.chatmessages.find().exec().then(x => setMessages(x));
            db.chatmessages.find().$.subscribe(x => {
                setMessages(x);
            });
        }
    }, [db]);
    const [userNameLoaded, setUserNameLoaded] = useState(false);
    useEffect(() => {
        if (lastMessageId !== messages[messages.length - 1]?.id) {
            // scrollEnd.current?.scrollIntoView({ behavior: "smooth" });
            scrollablePane.current?.scrollTo(0, scrollablePane.current.scrollHeight);
            setLastMessageId(messages[messages.length - 1]?.id || null);
        }
    }, [messages]);
    useEffect(() => {
        localConfigStorage.getValue("chatUsername").then(x => {
            setUserName(x);
            setUserNameLoaded(true);
        });
    }, []);

    const [userName, setUserName] = useState("");
    const [message, setMessage] = useState("");
    const [messageToShowTimestamp, setMessageToShowTimestamp] = useState<string | null>(null);

    const enterHandler = (e: KeyboardEvent) => {
        if (e.key === "Enter") {
            db?.chatmessages.insert({ id: new Date().getTime().toString(), from: { name: userName }, message: message });
            setMessage("");
        }
    }
    return (
        <div className="container">
            <h1>Chat{db && "."}</h1>
            <div className="d-flex flex-row align-items-center">
                <div className="input-group p-2">
                    <div className="input-group-prepend">
                        <span className="input-group-text">Chat Handle</span>
                    </div>
                    <input className="form-control form-control-sm" disabled={!userNameLoaded} type="text" value={userName} onInput={e => {
                        console.log(e.currentTarget.value);
                        setUserName(e.currentTarget.value);
                        localConfigStorage.storeValue("chatUsername", e.currentTarget.value);
                    }} />
                </div>
                <button className="btn btn-secondary btn-sm p-2 flex-shrink-0" onClick={() => authClient.login('https://datapod.igrant.io')}>Log {authClient.authenticated ? "out" : "in"}</button>
            </div>
            {userName && db && <input className="form-control mt-2" type="text" value={message} onInput={e => setMessage(e.currentTarget.value)} onKeyUp={enterHandler} />}
            <div className="container overflow-auto" style={{maxHeight: "50vh"}} ref={scrollablePane}>
                {messages.map(message => <div className="card p-1" style={{
                    "clear": "both",
                    "backgroundColor": stringToPastelColor(message.from.name),
                    "float": userName === message.from.name ? "right" : "left"
                }} key={message.id}
                onClick={e => {
                    if (e.shiftKey) {
                        message.remove();
                    } else {
                        if (messageToShowTimestamp === message.id) {
                            setMessageToShowTimestamp(null);
                        } else {
                            setMessageToShowTimestamp(message.id);
                        }
                    }
                }}
                title={`${new Date(parseInt(message.id)).toLocaleString()}`}
                onTouchStart={e => {
                    if (e.touches.length > 1) {
                        message.remove();
                    }
                }}
                {...(lastMessageId === message.id ? { ref: scrollEnd } : {})}>
                    <div><b>{(messageToShowTimestamp === message.id ? new Date(parseInt(message.id)).toLocaleString() + " " : "") + message.from.name}</b></div>
                    {message.message}
                </div>)}
                <div style={{"clear": "both"}}></div>
            </div>
        </div>
    );
}